import React, { useState } from 'react';
import styled from 'styled-components';
import { filter, is, range } from 'ramda';
import SongParser from './../service/SongParser';
import InlineChord from './InlineChord';
import withTune from './hocs/withTune';

const SongContent = styled.div`
    overflow: hidden;
`;

const SongTitle = styled.div`
    font-weight: bold;
    display: block;
    font-size: 16px;
    padding: 16px 0;
`;

const SongText = styled.div`
    font-family: 'Fira Mono', monospace;
    text-align: left;
    
    @media (max-width: 768px) {
        font-size: 12px;
        overflow-x: auto;
    }
`;

const SongRow = styled.div`
`;

const SongRowText = styled.span`
    position: relative;
    margin-left: 24px;
    
    @media (max-width: 768px) {
        margin-left: 18px;
    }
`;

const Spoiler = styled.span`
    position: relative;
    cursor: pointer;
    color: #820014;
    font-size: 14px;
`;

const renderChords = (chordsSequence, tune) => {
    const firstChords = filter((item) => item.position < 0, chordsSequence);

    const rowPrefix = firstChords.length <= 0 ? null : <span className='song-row-prelude'>
            {firstChords.map((item, key) => <span key={`chord-${key}`}>{item.chord}</span>)}
        </span>;

    const chords = filter((item) => item.position >= 0, chordsSequence);

    const chordsLine = [];
    let currentPosition = 0;
    chords.forEach((item, key) => {
        chordsLine.push(<span key={`chord-space-${key}`}>
                {range(0, item.position - currentPosition).reduce((memo) => memo + '\u00a0', '')}
            </span>);

        currentPosition += item.position - currentPosition;
        chordsLine.push(<InlineChord key={`chord-component-${key}`} tune={tune} name={item.name}/>);
        currentPosition += item.name.length;
    });

    return <>
        <SongRowText>
            {rowPrefix}
            {chordsLine}
        </SongRowText>
        <br/>
    </>
};

const renderRows = (rows, tune) => rows.map((row, key) => (
    <SongRow key={`song-row-${key}`}>
        {row.chords.length > 0 ? renderChords(row.chords, tune) : null}
        <SongRowText>{row.text}</SongRowText>
    </SongRow>
));

function Song({ title, text, children, tune }) {
    const [expanded, setExpanded] = useState(false);

    const parser = new SongParser();

    const renderSong = () => {
        text = text || children;

        const [mainPart, hiddenPart] = is(String, text) ? text.split('{spoiler}') : [text, ''];

        return <SongText>
            {renderRows(parser.parse(mainPart), tune)}
            {hiddenPart && (
                <>
                    <Spoiler style={{ display: !expanded ? 'block' : 'none' }} onClick={() => setExpanded(!expanded)}>- Показать полный текст песни -</Spoiler>
                    <div style={{ display: expanded ? 'block' : 'none' }}>
                        {renderRows(parser.parse(hiddenPart))}
                    </div>
                    <Spoiler style={{ display: expanded ? 'block' : 'none' }} onClick={() => setExpanded(!expanded)}>- Скрыть полный текст песни -</Spoiler>
                </>
            )
            }
        </SongText>
    };

    return <SongContent>
        {!!title && <SongTitle>{title}</SongTitle>}
        {renderSong()}
    </SongContent>
}

export default withTune(Song);
